import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

/** @deprecated  Exporting the component so that it can be used in other files. */
export default ExpansionPanelSummary;
